//购买支付
var buy = function (json_data) {
  var fullJson = JSON.stringify(json_data);
  // alert(fullJson)
  window.JavaScript.onPay(fullJson);
}
//获取用户信息
var getUserInfo = function () {
  var userInfo = JSON.parse(window.JavaScript.getInformation());
  return userInfo;
}

//查看是否登录
var isLogin = function () {
  var userInfo = getUserInfo();
  if (userInfo.uid === '' || userInfo.uid === undefined) {
      return false;
  }
  return true;
}
//登录
var login = function () {
  window.JavaScript.login();
}
//去离线词典
var toDict = function () {
  window.JavaScript.startActivity('{activity:com.kingsoft.OfflineDictActivity}');
}
//去到我的资料
var toMyMsg = function () {
  window.JavaScript.startActivity('{activity:com.kingsoft.PersonalCenterActivity}');
}
//去到课程
var toClass = function () {
  window.JavaScript.startActivity('{activity:com.kingsoft.CourseActivity,read_title:课程}');
}
//获取java 签名
var getSignatureForJava = function (data, url) {
  return window.JavaScript.getSignatureForJava(JSON.stringify(data), url);
}
//获取php 签名
var getSignatureForPHP = function (data) {
  return window.JavaScript.getSignature(JSON.stringify(data));
}
var toNovelList = function () {
  window.JavaScript.startActivity('{activity:com.kingsoft.FCActivity,fmname:menu-read,_statistic_flag:menu-read,MyListActivity:novel}');
}
var toBindTel = function () {
  window.JavaScript.startActivity("{activity:com.kingsoft.BindingTelephoneActivity,tip:'购买词霸会员\n凭手机号验证有效身份\n或者退出用手机号登录'}");
}
//判断是否登录与登录连锁
var isLoginGo = function () {
  var userInfo = getUserInfo();
  if (userInfo.uid === '' || userInfo.uid === undefined) {
      login();
      return false;
  } else {
      return true;
  }
}
//是否是VIP
var isVip = function () {
  var userInfo = getUserInfo();
  if (userInfo.isVip === 1) {
      return true;
  }
  return false;
}
var toBookDetail = function (bookId) {
  window.JavaScript.startActivity("{activity:com.kingsoft.activitys.BookDetailActivity,bookId:" + bookId + "}");
}
var androidAction = function (action) {
  window.JavaScript.startActivity(action);
}
/*
* 纯正音频   {activity:com.kingsoft.EbookFirstOperationModeActivity,web_bean_data_tag:{mapId=38,type=2,jumpTitle:牛津音频小说}}

  英文原版   {activity:com.kingsoft.EbookFirstOperationModeActivity,web_bean_data_tag:{mapId=39,type=2,jumpTitle:英文原版名著}}

  中英对照   {activity:com.kingsoft.EbookFirstOperationModeActivity,web_bean_data_tag:{mapId=40,type=2,jumpTitle:双语中英对照}}

  双语有声   {activity:com.kingsoft.EbookFirstOperationModeActivity,web_bean_data_tag:{mapId=41,type=2,jumpTitle:双语有声小说}}

  免费专区   {activity:com.kingsoft.EbookFirstOperationModeActivity,web_bean_data_tag:{mapId=59,type=2,jumpTitle:免费专区}}
  */
//纯正音频
var toPureAudio = function () {
  window.JavaScript.startActivity("{activity:com.kingsoft.EbookFirstOperationModeActivity,web_bean_data_tag:{mapId=38,type=2,jumpTitle:牛津音频小说}}");
}
//英文原版
var toEngOriginal = function () {
  window.JavaScript.startActivity("{activity:com.kingsoft.EbookFirstOperationModeActivity,web_bean_data_tag:{mapId=39,type=2,jumpTitle:英文原版名著}}");
}
//中英对照
var toChineseEng = function () {
  window.JavaScript.startActivity("{activity:com.kingsoft.EbookFirstOperationModeActivity,web_bean_data_tag:{mapId=40,type=2,jumpTitle:双语中英对照}}");
}
//双语有声
var toBilingual = function () {
  window.JavaScript.startActivity("{activity:com.kingsoft.EbookFirstOperationModeActivity,web_bean_data_tag:{mapId=41,type=2,jumpTitle:双语有声小说}}");
}
//免费专区
var toFree = function () {
  window.JavaScript.startActivity(" {activity:com.kingsoft.EbookFirstOperationModeActivity,web_bean_data_tag:{mapId=59,type=2,jumpTitle:免费专区}}");
}
//去首页卡片管理
var toCardSet = function () {
  window.JavaScript.startActivity("{activity:com.kingsoft.activitys.CardSelectionActivity}");
}

//去挑战
var toChallenge = function (contentId) {
  window.JavaScript.startActivity("{activity:com.kingsoft.millionplan.PreChallengeActivity,_useSpeBundle:true,integerParams:{id:"+contentId+"}}");
}

//去挑战历史
var toChallengeHis = function () {
  window.JavaScript.startActivity("{activity:com.kingsoft.millionplan.MillionChallengePastActivity,_useSpeBundle:true,integerParams:{activityId:1, entry:0}}")
}

//我的奖学金
var toMyScholarship = function () {
  window.JavaScript.startActivity("{activity:com.kingsoft.millionplan.MyScholarshipActivity}")
}




export default {
  buy: buy,
  login: login,
  getUserInfo: getUserInfo,
  toDict: toDict,
  toMyMsg: toMyMsg,
  toClass: toClass,
  isLogin: isLogin,
  getSignatureForJava: getSignatureForJava,
  getSignatureForPHP: getSignatureForPHP,
  toNovelList: toNovelList,
  toBindTel: toBindTel,
  isLoginGo: isLoginGo,
  isVip: isVip,
  toBookDetail: toBookDetail,
  androidAction: androidAction,
  toPureAudio: toPureAudio,
  toEngOriginal: toEngOriginal,
  toChineseEng: toChineseEng,
  toBilingual: toBilingual,
  toFree: toFree,
  toCardSet: toCardSet,
  toChallenge: toChallenge,
  toChallengeHis: toChallengeHis,
  toMyScholarship: toMyScholarship
}
